import firebase from 'firebase/app';
import 'firebase/analytics';

let firebaseCon = null;

const firebaseConfig = {
  apiKey: process.env.NALURI_APP_FIREBASE_API_KEY,
  authDomain: process.env.NALURI_APP_FIREBASE_APP_DOMAIN,
  databaseURL: process.env.NALURI_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.NALURI_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NALURI_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NALURI_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NALURI_APP_FIREBASE_APP_ID,
  measurementId: process.env.NALURI_APP_FIREBASE_MEASUREMENT_ID,
};

if (!firebaseCon) {
  firebaseCon = firebase.initializeApp(firebaseConfig);
}

export default firebaseCon;



// WEBPACK FOOTER //
// ./src/common/analytics/firebase.js